module.exports = __webpack_public_path__ + "static/img/MA@2x.4c93cb87.jpg";